export default __webpack_public_path__ + "static/media/bg_03.adca8758.png";